// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"step-section_wrapper__2S8oo","headline":"step-section_headline__aH2lF"};